import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ResultCalculationsService} from '../result-calculations.service';
import {KetoParams} from '../ketoParams';
import {KetoResult} from '../ketoResult';
import {ResultType} from './ResultType';

@Component({
  selector: 'app-keto-calculator',
  templateUrl: './keto-calculator.component.html',
  styleUrls: ['./keto-calculator.component.css']
})
export class KetoCalculatorComponent implements OnInit {

  title = 'KetoCalculator';

  result: KetoResult;

  resultLoseWeight: KetoResult;

  resultGainWeight: KetoResult;

  resultType: ResultType;

  activities = [
    {value: 0, viewValue: 'Znikomy/Siedzący'},
    {value: 0.25, viewValue: 'Lekko aktywny'},
    {value: 0.5, viewValue: 'Umiarkowany'},
    {value: 0.75, viewValue: 'Bardzo aktywny'},
    {value: 1, viewValue: 'Sportowcy/Kulturyści'},
  ];

  ketoForm = new FormGroup({
    gender : new FormControl('female', [
      Validators.required
    ]),
    age : new FormControl(30, [
      Validators.required,
      Validators.pattern('^[1-9][0-9]$')
    ]),
    weight : new FormControl(70, [
      Validators.required,
      Validators.pattern('([1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])$')
    ]),
    height : new FormControl(165, [
      Validators.required,
      Validators.pattern('^1[0-9][0-9]|2[0-4][0-9]$')
    ]),
    activityLevel : new FormControl(0.25, [
      Validators.required
    ]),
    bodyFat : new FormControl(25, [
      Validators.required,
      Validators.pattern('^[1-9][0-9]?$|^100$')
    ]),
    netCarbs : new FormControl(20, [
      Validators.required,
      Validators.pattern('^[1-9][0-9]?$|^100$')
    ])
  });
  submitted = false;

  constructor(private resultCalculationsService: ResultCalculationsService) {
  }

  ngOnInit() {
  }

  onSubmit(element: HTMLElement) {
    this.maintenance(element);
  }

  goBack(element) {
    this.submitted = false;
    element.scrollIntoView();
  }

  maintenance(element: HTMLElement) {
    this.submitted = true;

    const params = new KetoParams();
    params.gender = this.ketoForm.get('gender').value;
    params.age = this.ketoForm.get('age').value;
    params.weight = this.ketoForm.get('weight').value;
    params.height = this.ketoForm.get('height').value;
    params.fat = this.ketoForm.get('bodyFat').value;
    params.carbs = this.ketoForm.get('netCarbs').value;
    params.activity = this.ketoForm.get('activityLevel').value;
    params.adjustment = 0;

    this.result = this.resultCalculationsService.getLogic(params);
    this.resultType = ResultType.Maintenance;
    element.scrollIntoView();
  }


  loseWeight(element: HTMLElement) {
    this.submitted = true;

    const params = new KetoParams();
    params.gender = this.ketoForm.get('gender').value;
    params.age = this.ketoForm.get('age').value;
    params.weight = this.ketoForm.get('weight').value;
    params.height = this.ketoForm.get('height').value;
    params.fat = this.ketoForm.get('bodyFat').value;
    params.carbs = this.ketoForm.get('netCarbs').value;
    params.activity = this.ketoForm.get('activityLevel').value;
    params.adjustment = -10;

    this.resultLoseWeight = this.resultCalculationsService.getLogic(params);
    this.resultType = ResultType.LoseWeight;
    element.scrollIntoView();
  }

  gainWeight(element: HTMLElement) {
    this.submitted = true;

    const params = new KetoParams();
    params.gender = this.ketoForm.get('gender').value;
    params.age = this.ketoForm.get('age').value;
    params.weight = this.ketoForm.get('weight').value;
    params.height = this.ketoForm.get('height').value;
    params.fat = this.ketoForm.get('bodyFat').value;
    params.carbs = this.ketoForm.get('netCarbs').value;
    params.activity = this.ketoForm.get('activityLevel').value;
    params.adjustment = 10;

    this.resultGainWeight = this.resultCalculationsService.getLogic(params);
    this.resultType = ResultType.GainWeight;
    element.scrollIntoView();
  }

  public isMaintenance(resultType: ResultType): boolean {
    return (resultType === ResultType.Maintenance);
  }

  public isLoseWeight(resultType: ResultType): boolean {
    return (resultType === ResultType.LoseWeight);
  }

  public isGainWeight(resultType: ResultType): boolean {
    return (resultType === ResultType.GainWeight);
  }
}

